import { Menu } from '@blueprintjs/core';
import { ContextMenu2ContentProps } from '@blueprintjs/popover2';
import React from 'react';
import { MultiCalendarSelectionType } from './MultiCalendar';
import { ToolboxToolPart } from './ToolboxParts';
import { WithTranslateProps } from './WithTranslate';

interface CalendarContextMenuProps extends WithTranslateProps {
  selectedType: MultiCalendarSelectionType | undefined;
  onTypeClicked: (MultiCalendarSelectionType) => void;
  blackPointHolidayCount?: number;
  blackPointHolidayMax?: number;
  isSecretariat?: boolean;
}

export const CalendarContextMenu = (props: CalendarContextMenuProps & ContextMenu2ContentProps) => {
  return (
    <div
      style={{
        position: 'fixed',
        backgroundColor: 'white',
        borderRadius: '5px',
        borderColor: 'black',
        borderWidth: '2px',
        borderStyle: 'solid',
      }}
    >
      <Menu id={'contexMenu'}>
        <ToolboxToolPart
          id={'bpHoliday1'}
          selectedType={props.selectedType}
          onTypeClicked={props.onTypeClicked}
          translate={props.translate}
          blackPointHolidayCount={props.blackPointHolidayCount}
          blackPointHolidayMax={props.blackPointHolidayMax}
          isSecretariat={props.isSecretariat}
          style={{ margin: '5px', display: 'flex' }}
          hideTitle
        />
      </Menu>
    </div>
  );
};
